import { useMutation, useQueryClient } from "react-query"
import { InfiniteState } from "../../hooks/types"
import { deleteCustomArticleLists } from "../deleteCustomArticleList"
import { ShowCustomArticleListsResponse } from "../models"
import { QUERY_KEY_LISTS } from "./keys"

export function useDeleteCustomArticleLists() {
    const queryClient = useQueryClient()

    return useMutation(deleteCustomArticleLists, {
        onSuccess: (_, request) => {
            queryClient.setQueriesData<InfiniteState<ShowCustomArticleListsResponse>>(QUERY_KEY_LISTS, (prev) => {
                return {
                    ...prev,
                    pages:
                        prev?.pages.map((page) => ({
                            ...page,
                            data: {
                                ...page.data,
                                customArticleLists: page.data.customArticleLists.filter((x) => !request.idList.includes(x.id)),
                            },
                        })) ?? [],
                }
            })
        },
    })
}
